import Vue from 'vue'
import VueRouter from 'vue-router'
import Note from '@/views/Note'
import Feedback from '@/views/Feedback'

Vue.use(VueRouter)

export function createRouter(store) {
  const viewMode = store.state.viewModes.find(m => m.name === 'note')
  const routes = [
    {
      path: '/',
      alias: '/index.html',
      name: 'rootNote',
      component: Note,
      props: { viewMode }
    }, {
      path: '/c/:contextion/:viewMode?',
      name: 'noteByContextion',
      component: Note,
      props: { default: true, viewMode }
      // }, {
      //   path: '/account',
      //   name: 'account',
      //   component: Account,
      //   meta: { requiresAuth: true }
    }, {
      path: '/feedback',
      component: Feedback
    }
  ]

  const router = new VueRouter({
    mode: 'history',
    routes,
    scrollBehavior(to, from, savedPosition) {
      return { x: 0, y: 0 }
    }
  })

  // initializeFirebase(store)
  // router.beforeEach(async (to, from, next) => {
  //   const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  //   if (requiresAuth) {
  //     init.then(() => {
  //       const user = store.state.user
  //       if (user) {
  //         next()
  //       } else {
  //         next({ name: 'rootNote' })
  //       }
  //     })
  //   } else {
  //     next()
  //   }
  // })
  return router
}
